import script from "./SortOptionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortOptionsModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__